import {tPatientModel} from 'src/app/models/tPatientModel';
import {tConsultHeadModel} from 'src/app/models/tConsultHeadModel';
import {tEmployeeModel} from 'src/app/models/tEmployeeModel';
import {tShopModel} from 'src/app/models/tShopModel';
export class letterElementModel{
    patientData:tPatientModel;
    consultData:tConsultHeadModel;
    shopData:tShopModel;
    caseDoctorData:tEmployeeModel;
    treatDoctorData:tEmployeeModel;
}

export class letterElementIDModel{
    patientID=/#patientID/g;
    patientHKID=/#patientHKID/g;
    patientFullHKID=/#patientFullHKID/g;

    patientHKIDRemark=/#nonHKID_remark/g;
    patientRemark2=/#patientRemark2/g;
    patientName=/#patientName/g;
    patientName_ENG=/#patientName_ENG/g;
    patientGender=/#patient_gender/g;
    patientDob=/#patient_DOB/g;

    patientAddress=/#patient_address/g;
    patientPhone=/#patient_Tel/g;
    patientPhone2=/#patient_Other_Tel/g;

    patientPronouns=/#patient_Pronouns/g;


    clinic_address1=/#clinic_address1/g;
    clinic_address2=/#clinic_address2/g;
    clinic_address3=/#clinic_address3/g;
    consultNumber=/#consultNo/g;
    prescriptionNumber=/#presNo/g;
    shopName=/#shopName/g;
    printDate=/#print_Date/g;
    consultDate=/#consult_Date/g;

    caseDoctorName=/#caseDoctorName_CHI/g;
    caseDoctorName_ENG=/#caseDoctorName_ENG/g;
    caseDoctorRemark3=/#caseDoctor_ReceiptTitle/g;
    treatDoctorName=/#treatDoctorName_CHI/g;
    treatDoctorName_ENG=/#treatDoctorName_ENG/g;
    treatDoctorDrCMP=/#treatDoctorDrCMP/g;
    trearDoctorRemark3=/#treatDoctor_ReceiptTitle/g;


    consult_diagnosis=/#consult_diagnosis/g;
    consult_notes=/#consult_notes/g;
    consult_doctorOrder=/#consult_doctorOrder/g;
    consult_allergy=/#consult_allergy/g;
}
export class elementListModel{
id:number;
desc:string;
value:string;

constructor(id,desc,value){
    this.id=id;
    this.desc=desc;
    this.value=value;
}
}



